import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/examine/:key?',
    name: 'examine',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/examine/Examine.vue'),
    meta: {
      orgPackCodeType: [
        i18nEnum.OrganizationPackCodeType.PTC,
        i18nEnum.OrganizationPackCodeType.DVCQSN,
        i18nEnum.OrganizationPackCodeType.STC,
      ],
    },
  },
  {
    path: '/examine-initial/:key?',
    name: 'examine-initial',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/examine/ExamineInitial.vue'),
    meta: {
      orgPackCodeType: [
        i18nEnum.OrganizationPackCodeType.PTC,
        i18nEnum.OrganizationPackCodeType.DVCQSN,
        i18nEnum.OrganizationPackCodeType.STC,
      ],
    },
  },
  {
    path: '/three-year-examine/:key?',
    name: 'three-year-examine',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/examine/ThreeYearExamine.vue'),
    meta: {
      orgPackCodeType: [
        i18nEnum.OrganizationPackCodeType.PTC,
        i18nEnum.OrganizationPackCodeType.DVCQSN,
        i18nEnum.OrganizationPackCodeType.STC,
      ],
    },
  },
];
